import { gql } from '@apollo/client'

export const GET_USERS = gql`
  query GetUsers($limit: Int!, $page: Int!, $isActive: Boolean, $user: ID) {
    users(pagination: { size: $limit, page: $page }, input: { isActive: $isActive, id: $user }) {
      total
      items {
        id
        username
        firstName
        lastName
        email
        position
        isActive
        isBlocked
        companies {
          id
          name
        }
        permissions {
          id
          name
        }
        roles {
          id
          name
          permissions {
            id
            name
          }
        }
      }
    }
  }
`

export const GET_USER = gql`
  query GetUser($userId: ID!) {
    user(input: { id: $userId }) {
      id
      firstName
      lastName
      username
      email
      position
      mfaEnabled
      passwordExpirationEnabled
      companies {
        id
        name
        vertical
        policyRole {
          id
          name
        }
      }
      permissions {
        id
        name
      }
      roles {
        id
        name
        permissions {
          id
          name
        }
      }
    }
  }
`

export const USER_SUGGESTION_FRAGMENT = gql`
  fragment UserSuggestionFragment on UserSuggestion {
    id
    name
    username
    firstName
    lastName
  }
`

export const GET_USERS_SUGGESTIONS = gql`
  query GetUsersSuggestions($input: UserSuggestionsInput!) {
    userSuggestions(input: $input) {
      total
      items {
        ...UserSuggestionFragment
      }
    }
  }
  ${USER_SUGGESTION_FRAGMENT}
`
